import type { FieldValues } from 'react-hook-form';

import { useGetImpactList } from '@/hooks/queries';

import ControlledSelect from '../controlled-select';
import type { ControlledBaseProps } from '../types';

interface Props<T extends FieldValues> extends ControlledBaseProps<T> {
  addEmptyOption?: boolean;
  disabled?: boolean;
  single?: boolean;
  testId: string;
}

export const ControlledImpactSelect = <T extends FieldValues>({
  ...props
}: Props<T>) => {
  const { data, loading } = useGetImpactList({
    queryArgs: {},
  });

  const options =
    data?.impact.map((r) => ({
      value: r.Id,
      label: r.Name,
    })) ?? [];

  return (
    <ControlledSelect
      statusType={loading ? 'loading' : 'finished'}
      {...props}
      options={options}
    />
  );
};
